import {
  FETCH_POSTS_REQUEST,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_FAILURE
} from './postsActionTypes'
import {
  CREATE_APPOINTMENT_REQUEST,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILURE
} from './postsActions'

const initialState = {
  posts: [],
  pagination: {
    count: 0,
    next: null,
    previous: null
  },
  loading: false,
  error: null,
  appointmentLoading: false,
  appointmentError: null,
  appointmentSuccess: false,
}

export default function postsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_POSTS_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_POSTS_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: Array.isArray(action.payload.results) ? action.payload.results : [],
        pagination: {
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous
        }
      }
    case FETCH_POSTS_FAILURE:
      return { ...state, loading: false, error: action.error }
    case CREATE_APPOINTMENT_REQUEST:
      return { ...state, appointmentLoading: true, appointmentError: null, appointmentSuccess: false }
    case CREATE_APPOINTMENT_SUCCESS:
      return { ...state, appointmentLoading: false, appointmentSuccess: true }
    case CREATE_APPOINTMENT_FAILURE:
      return { ...state, appointmentLoading: false, appointmentError: action.error, appointmentSuccess: false }
    case 'RESET_APPOINTMENT_SUCCESS':
      return { ...state, appointmentSuccess: false, appointmentError: null }
    default:
      return state
  }
}
